import { h } from 'preact';

export default () => ((
  <div className="w-loading-dots">
    <div />
    <div />
    <div />
  </div>
));



// WEBPACK FOOTER //
// ./components/LoadingDots.js